<template>
  <Tag :severity="severity">
    {{ t(`refundStatus.${refundStatus}`) }}
  </Tag>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  isFullRefund: {
    type: Boolean,
    default: false,
  },
  isRefundDeclined: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const refundStatus = computed(() => {
  if (props.isFullRefund) return 'full';
  if (!props.isRefundDeclined) return 'partial';
  return 'declined';
});

const severity = computed(() => {
  return refundStatus.value === 'declined' ? 'danger' : 'info';
});
</script>
